import { Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalBody, ModalFooter, Button, Box, Flex, Text, Icon } from "@chakra-ui/react";
import { FaExclamationTriangle, FaPlus } from "react-icons/fa";
import EntryTable from "./EntryTable";

const PropertyEntriesModal = ({ property, isOpen, onClose, onEdit, onDeactivate }) => {
    if (!property) return null;

    const problems = property.entries.filter((entry) => entry.isProblem && entry.isActive).length;

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside" isCentered>
            <ModalOverlay bg="blackAlpha.600" />
            <ModalContent borderRadius="2xl" overflow="hidden" mx={4}>
                <Box bg="brand.700" px={6} py={5}>
                    <Flex align="center" gap={3}>
                        <Box minW={0} flex="1">
                            <Text fontSize="lg" fontWeight="700" color="white" noOfLines={1}>
                                {property.name}
                            </Text>
                            {problems > 0 && (
                                <Flex align="center" gap={1} mt={1} bg="red.500" color="white" borderRadius="full" px={2} py={0.5} display="inline-flex">
                                    <Icon as={FaExclamationTriangle} boxSize={2.5} />
                                    <Text fontSize="xs" fontWeight="700">
                                        {problems} {problems === 1 ? "problem" : "problema"}
                                    </Text>
                                </Flex>
                            )}
                        </Box>
                    </Flex>
                </Box>
                <ModalCloseButton color="white" top={5} right={5} />

                <ModalBody px={6} py={5}>
                    <EntryTable
                        entries={property.entries}
                        onEdit={onEdit}
                        onDeactivate={onDeactivate}
                    />
                </ModalBody>

                <ModalFooter borderTop="1px solid" borderColor="gray.100" gap={3}>
                    <Button
                        leftIcon={<FaPlus />}
                        bg="brand.600"
                        color="white"
                        borderRadius="full"
                        _hover={{ bg: "brand.700" }}
                        onClick={() => onEdit("entry", { subjectName: "", expirationDate: "", propertyId: property.id, propertyName: property.name })}
                    >
                        Dodaj unos
                    </Button>
                    <Button variant="ghost" onClick={onClose}>Zatvori</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default PropertyEntriesModal;
